export default [
  // 知识
  {
    path: '/doc',
    name: 'doc',
    component: () => import('@/CommonDP/pages/mainMg/doc/knowledgeMenu.vue'),
    meta: {
      routeName: '知识',
      icon: require('@/CommonDP/assets/settings/doc.svg')
    },
    children: [
      {
        path: '/persondoc',
        name: 'persondoc',
        component: () => import('@/CommonDP/pages/mainMg/doc/routerView.vue'),
        meta: {
          routeName: '个人文档',
          prouteName: '个人文档',
          pname: '知识',
          icon1: require('@/CommonDP/assets/doc/persondoc.svg'),
          icon2: require('@/CommonDP/assets/doc/persondoc.svg')
        },
        children: [
          {
            path: '/mydoc',
            name: 'mydoc',
            component: () => import('@/CommonDP/pages/mainMg/doc/myDoc/myDoc'),
            meta: {
              hideSubMenu: true,
              routeName: '我的文档',
              prouteName: '个人文档/我的文档',
              ppname: '知识'
            }
          },
          {
            path: '/myshare',
            name: 'myshare',
            component: () => import('@/CommonDP/pages/mainMg/doc/myShare/myShare'),
            meta: {
              hideSubMenu: true,
              routeName: '我的分享',
              prouteName: '个人文档/我的分享',
              ppname: '知识'
            }
          },
          {
            path: '/mycollection',
            name: 'mycollection',
            component: () => import('@/CommonDP/pages/mainMg/doc/myFavorite/myFavorite'),
            meta: {
              hideSubMenu: true,
              routeName: '我的收藏',
              prouteName: '个人文档/我的收藏',
              ppname: '知识'
            }
          },
          {
            path: '/myrecycle',
            name: 'myrecycle',
            component: () => import('@/CommonDP/pages/components/recycle'),
            props: { type: 2 },
            meta: {
              hideSubMenu: true,
              routeName: '回收站',
              prouteName: '个人文档/回收站',
              ppname: '知识'
            }
          }
        ]
      },
      {
        path: '/enterprisedoc',
        name: 'enterprisedoc',
        component: () => import('@/CommonDP/pages/mainMg/doc/routerView.vue'),
        meta: {
          routeName: '企业文档',
          prouteName: '企业文档',
          pname: '知识',
          icon1: require('@/CommonDP/assets/doc/enterprisedoc.svg'),
          icon2: require('@/CommonDP/assets/doc/enterprisedoc.svg')
        },
        children: [
          {
            path: '/sharinformation',
            name: 'sharinformation',
            component: () => import('@/CommonDP/pages/mainMg/doc/sharinFormation/sharinFormation'),
            meta: {
              hideSubMenu: true,
              routeName: '分享资料',
              prouteName: '企业文档/分享资料',
              ppname: '知识'
            }
          },
          {
            path: '/Publicinformation',
            name: 'publicinformation',
            component: () => import('@/CommonDP/pages/mainMg/doc/publicinFormation/publicinFormation'),
            meta: {
              hideSubMenu: true,
              routeName: '公共资料',
              prouteName: '企业文档/公共资料',
              ppname: '知识'
            }
          },
          {
            path: '/entprecycle',
            name: 'entprecycle',
            component: () => import('@/CommonDP/pages/components/recycle'),
            props: { type: 3 },
            meta: {
              hideSubMenu: true,
              routeName: '回收站',
              prouteName: '企业文档/回收站',
              ppname: '知识'
            }
          }
        ]
      },
      {
        path: '/enterpriseDeptDoc',
        name: 'enterpriseDeptDoc',
        component: () => import('@/CommonDP/pages/mainMg/doc/enterpriseDeptDoc/index.vue'),
        meta: {
          hideSubMenu: true,
          routeName: '部门文档',
          prouteName: '部门文档',
          pname: '知识',
          icon1: require('@/CommonDP/assets/doc/enterpriseDeptDoc.svg'),
          icon2: require('@/CommonDP/assets/doc/enterpriseDeptDoc.svg')
        },
        children: []
      }
    ]
  }
];
